module.exports = __webpack_public_path__ + "static/media/folder-tree.ab4cff26.svg";